import { apiClient, API_CONFIG } from '../../../core';
import type { ApiResponse } from '../../../shared';
import { buildQueryString } from '../../../shared';
import type {
  GetEmployeesFilteredParams,
  LC_GetEmployeesFilteredIn,
  LC_GetEmployeesFilteredOut,
  FilteredEmployeesPage,
} from '../types';
import { mapFilteredEmployeesPage } from '../mappers';


function toCSV(ids?: string[]): string | null {
  return ids && ids.length > 0 ? ids.join(',') : null;
}

function numbersToCSV(ids?: number[]): string | null {
  return ids && ids.length > 0 ? ids.join(',') : null;
}

export class EmployeeFilteredService {
  async getFiltered(
    params: GetEmployeesFilteredParams,
    signal?: AbortSignal,
  ): Promise<ApiResponse<FilteredEmployeesPage>> {
    const dto: LC_GetEmployeesFilteredIn = {
      companyIds: toCSV(params.companyIds),
      areaIds: toCSV(params.areaIds),
      positionIds: toCSV(params.positionIds),
      costCenterIds: toCSV(params.costCenterIds),
      locationIds: toCSV(params.locationIds),
      contractModalityIds: toCSV(params.contractModalityIds),
      groupIds: toCSV(params.groupIds),
      status: params.status ?? null,
      searchText: params.searchText ?? null,
      page: params.page,
      pageSize: params.pageSize,
      employeeIds: numbersToCSV(params.employeeIds),
    };

    const queryString = buildQueryString({ ...dto });
    const endpoint = `${API_CONFIG.ENDPOINTS.EMPLOYEES.FILTERED}${queryString}`;

    const response = await apiClient.get<LC_GetEmployeesFilteredOut>(endpoint, { signal });

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapFilteredEmployeesPage(response.data) };
  }
}

export const employeeFilteredService = new EmployeeFilteredService();
